export default __webpack_public_path__ + "static/media/CheckCircle (2).9a78354c.svg";